import "./style.scss";
import * as React from "react";
import { StoreVisitsProps, StoreVisitsActions } from "./container";
import { QuerySelector, MerchantBadge } from "../../../common";
import { TopStoresTableContainer } from "../TopStoresTable";
import {
  generateQueryString,
  parseQueryString
} from "../../../../modules/common/utils";
import { sendGAEvent, ViewContext } from "../../../common/google_analytics";

export class StoreVisitsContainer extends React.Component<
  StoreVisitsProps & StoreVisitsActions & RouterChildProps,
  {}
> {
  componentWillMount() {
    this.props.removePublications();
    this.setStateFromQuery();
    this.props.getMerchants("#");
  }

  setStateFromQuery() {
    //sanitizes and uses URL as source of truth on state of application
    this.props.syncQueryString(this.props.history.location.search);
  }

  componentDidMount() {
    let __this = this;
    window.addEventListener("popstate", function (e) {
      __this.setStateFromQuery();
    });
  }

  handleQuerySelectorSubmition(
    publicationIds: number[],
    startDate: string,
    endDate: string,
    merchantId: number
  ) {
    //Query selector callback function to sync it's selections to state tree/url
    this.props.setEndDate(endDate);
    this.props.setStartDate(startDate);
    this.props.setMerchantSelection(merchantId);
    this.props.setPublicationSelection(publicationIds);

    const queryProps = parseQueryString(this.props.history.location.search);
    const queryString = generateQueryString({
      ...queryProps,
      flyer_run_ids: publicationIds,
      start_date: startDate,
      end_date: endDate,
      merchant: merchantId
    });
    this.props.history.push(`?${queryString}`);

    const { userContext } = this.props;
    const viewContext: ViewContext = {
      startDate,
      endDate,
      numPublications: `${publicationIds.length}`
    };
    const currentMerchant = this.props.merchants.find(
      ({ id }) => id == merchantId
    );
    sendGAEvent("Store Visits", "Show Data", currentMerchant.name, {
      ...userContext,
      ...viewContext
    });
  }

  render() {
    let merchants = this.props.merchants ? this.props.merchants : [];
    let selectedMerchant = merchants.find(
      (i: any) => i.id == this.props.merchantId
    );
    return (
      <div className="store-visits-container">
        <div className="section selector-wrapper">
          <MerchantBadge selectedMerchant={selectedMerchant} />
          <div className="right-section">
            <QuerySelector
              {...this.props}
              selectedMerchant={selectedMerchant}
              handleSubmit={this.handleQuerySelectorSubmition.bind(this)}
            />
          </div>
        </div>
        <div className="store-visits-container-body">
          <TopStoresTableContainer />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./client/modules/StoreVisits/components/StoreVisitsContainer/component.tsx